const colors = {
  background: '246,251,253,1',
  black: '0,0,0',
  grey: '74,74,74,1',
  primary: '36,148,187',
  published: '113,113,113,1',
  secondary: '16,107,139,1',
  text: '43,43,43,1',
  white: '255,255,255,1',
}

export default colors
